import { useGetAccountIdByProjectQuery } from '@frameio/graphql-client/generated';
import { useActiveProjectId } from '@frameio/shared/contexts';

export const useIsCSCProject = () => {
  const projectId = useActiveProjectId();
  const { data, loading } = useGetAccountIdByProjectQuery({
    variables: {
      projectId,
    },
    fetchPolicy: 'cache-first',
    skip: !projectId,
  });
  return !loading && typeof data?.account?.project?.adobeAssetId === 'string';
};
